export default __webpack_public_path__ + "static/media/new_store_banner.1124dff0.png";